import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { EmptyState } from "@/components/EmptyState";
import { documentTitlePage } from "@/constants/app";
import { hr } from "@/constants/strings.hr";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export function NotFoundPage() {
  const navigate = useNavigate();

  useDocumentTitle(documentTitlePage("404"));

  return (
    <EmptyState title="404" titleVariant="h2">
      <Typography
        variant="h5"
        sx={{
          color: "text.secondary",
          mb: 3,
          mt: 1,
        }}
      >
        {hr.notFound.title}
      </Typography>
      <Button variant="contained" onClick={() => navigate("/")}>
        {hr.notFound.backHome}
      </Button>
    </EmptyState>
  );
}
